// @src/utils/iconMap.ts
import {
	IconAvatar,
	IconTree,
	IconList,
	IconForm,
	IconButton,
	IconToken,
	IconConfig,
	IconChangelog,
	IconPincode,
	IconNotification,
	IconTag
} from '@douyinfe/semi-icons-lab'
import {
	IconTickCircle,
	IconHelpCircle,
	IconUser,
	IconUserGroup,
	IconSetting,
	IconLink,
	IconRefresh,
	IconPlus,
	IconSearch,
	IconClose,
	IconSend,
	IconVolume1,
	IconHome,
	IconPhone
} from '@douyinfe/semi-icons'

export const IconMap: Record<string, React.ComponentType> = {
	IconAvatar,
	IconTree,
	IconList,
	IconForm,
	IconButton,
	IconToken,
	IconTickCircle,
	IconNotification,
	IconConfig,
	IconChangelog,
	IconHelpCircle,
	IconPincode,
	IconTag,
	IconUser,
	// 历史 IconMap 里 'IconUsers' 这个 key 已被外部引用,继续保留,
	// 实际绑定到真实存在的 IconUserGroup(多人图标,语义对应)。
	IconUsers: IconUserGroup,
	IconUserGroup,
	IconSetting,
	IconLink,
	IconRefresh,
	IconPlus,
	IconSearch,
	IconClose,
	IconSend,
	// 同上,'IconVolume' 历史上用过,现在官方拆分为 Volume1/2,继续保留 key 但指向 Volume1
	IconVolume: IconVolume1,
	IconVolume1,
	IconHome,
	IconPhone
}
